import type {
  AssistantBulkMuteChannel,
  AssistantFutureMuteChannel,
} from '../types/Company';

export const ASSISTANT_MUTE_CHANNELS: Array<{
  key: AssistantBulkMuteChannel;
  labelKey: string;
}> = [
  { key: 'whatsapp', labelKey: 'assistantBulkMuteChannelWhatsApp' },
  { key: 'instagram', labelKey: 'assistantBulkMuteChannelInstagram' },
  { key: 'telegram', labelKey: 'assistantBulkMuteChannelTelegram' },
  { key: 'messenger', labelKey: 'assistantBulkMuteChannelMessenger' },
  { key: 'webchat', labelKey: 'assistantBulkMuteChannelWebchat' },
  { key: 'tiktok', labelKey: 'assistantBulkMuteChannelTikTok' },
  { key: 'voice', labelKey: 'assistantBulkMuteChannelVoice' },
];

const COMMENT_SURFACE_BY_PARENT: Partial<Record<AssistantBulkMuteChannel, AssistantFutureMuteChannel>> = {
  instagram: 'instagram_comments',
  messenger: 'messenger_comments',
};

export const ASSISTANT_FUTURE_MUTE_CHANNELS: Array<{
  key: AssistantBulkMuteChannel;
  labelKey: string;
  /** When set, show separate DM + Comments switches instead of one channel switch. */
  commentSurfaceKey?: AssistantFutureMuteChannel;
  dmLabelKey?: string;
  commentsLabelKey?: string;
}> = ASSISTANT_MUTE_CHANNELS.map(channel => {
  const commentSurfaceKey = COMMENT_SURFACE_BY_PARENT[channel.key];
  if (!commentSurfaceKey) {
    return channel;
  }

  return {
    ...channel,
    commentSurfaceKey,
    dmLabelKey: 'assistantFutureMuteSurfaceDms',
    commentsLabelKey: 'assistantFutureMuteSurfaceComments',
  };
});

const PARENT_BY_COMMENT_SURFACE: Partial<Record<AssistantFutureMuteChannel, AssistantBulkMuteChannel>> = {
  instagram_comments: 'instagram',
  messenger_comments: 'messenger',
};

export const ASSISTANT_FUTURE_MUTE_CHANNEL_KEYS: AssistantFutureMuteChannel[] = [
  ...ASSISTANT_MUTE_CHANNELS.map(channel => channel.key),
  'instagram_comments',
  'messenger_comments',
];

export const resolveInboundAiEnabledForChannel = (
  globalEnabled: boolean,
  channelSettings: Partial<Record<AssistantFutureMuteChannel, boolean>>,
  channel: AssistantFutureMuteChannel | null,
): boolean => {
  if (!channel) {
    return globalEnabled;
  }

  const override = channelSettings[channel];
  if (override !== undefined) {
    return override;
  }

  const parent = PARENT_BY_COMMENT_SURFACE[channel];
  if (parent) {
    const parentOverride = channelSettings[parent];
    if (parentOverride !== undefined) {
      return parentOverride;
    }
  }

  return globalEnabled;
};
